"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("../config");
var ProcessBase = /** @class */ (function () {
    function ProcessBase(config) {
        this.config = config;
    }
    /**
     * 通过参数配置获取图片链接
     * @param config 图片处理配置
     */
    ProcessBase.prototype.processImage = function (url, config, extendConfig) {
        var type = this.config.type;
        var cloud = (type || '').toLowerCase();
        var res = '';
        if (cloud) {
            res += config_1.CloudServer[cloud].processImage(url, config);
        }
        if (extendConfig && extendConfig[cloud]) {
            res += extendConfig[cloud];
        }
        return res;
    };
    return ProcessBase;
}());
exports.ProcessBase = ProcessBase;
exports.default = ProcessBase;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJvY2Vzc0Jhc2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbHMvUHJvY2Vzc0Jhc2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxvQ0FBa0Q7QUFpQmxEO0lBQ0UscUJBQVksTUFBcUI7UUFDL0IsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUE7SUFDdEIsQ0FBQztJQUtEOzs7T0FHRztJQUNILGtDQUFZLEdBQVosVUFBYSxHQUFXLEVBQUUsTUFBMEIsRUFBRSxZQUEyQjtRQUN2RSxJQUFBLHVCQUFJLENBQWdCO1FBQzVCLElBQU0sS0FBSyxHQUFHLENBQUMsSUFBSSxJQUFJLEVBQUUsQ0FBQyxDQUFDLFdBQVcsRUFBRSxDQUFBO1FBQ3hDLElBQUksR0FBRyxHQUFHLEVBQUUsQ0FBQTtRQUNaLElBQUksS0FBSyxFQUFFO1lBQ1QsR0FBRyxJQUFJLG9CQUFXLENBQUMsS0FBSyxDQUFDLENBQUMsWUFBWSxDQUFDLEdBQUcsRUFBRSxNQUFNLENBQUMsQ0FBQTtTQUNwRDtRQUNELElBQUksWUFBWSxJQUFJLFlBQVksQ0FBQyxLQUFLLENBQUMsRUFBRTtZQUN2QyxHQUFHLElBQUksWUFBWSxDQUFDLEtBQUssQ0FBQyxDQUFBO1NBQzNCO1FBQ0QsT0FBTyxHQUFHLENBQUE7SUFDWixDQUFDO0lBQ0gsa0JBQUM7QUFBRCxDQUFDLEFBeEJELElBd0JDO0FBeEJZLGtDQUFXO0FBMEJ4QixrQkFBZSxXQUFXLENBQUEifQ==